import { getLanguageFromLocaleTag, } from '@stepstone-platform/platform-apis';
import { API_URLS } from '../../constants/urls.js';
import { googleAuthReturnUrl } from '../utils.js';
export const googleAuthUrl = ({ loginSource, redirectionUrl, currentLocale, checkboxState, formType, }) => {
    const params = {
        returnUrl: googleAuthReturnUrl(currentLocale, redirectionUrl, formType, loginSource, checkboxState),
        loginSource,
        lang: getLanguageFromLocaleTag(currentLocale),
    };
    if (checkboxState) {
        params.thirdPartyMarketingContentEmail = String(checkboxState);
    }
    const queryString = Object.entries(params)
        .reduce((acc, [key, value]) => {
        if (value) {
            acc.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
        return acc;
    }, [])
        .join('&');
    return `${API_URLS.BFF.GOOGLE_AUTH}?${queryString}`;
};
//# sourceMappingURL=googleAuth.js.map